import { useAtomValue, useSetAtom } from "jotai";
import { v4 as uuidv4 } from "uuid";

import {
  BookingWizardDataAtom,
  CurrentRequestGroupIndexAtom,
} from "@/features/BookingWizard/atoms/stores";

import { NewGuestFormProps } from "../../../../../../../features/AddPatrons/types";
import { currentProfileAtom } from "../../../../../../../features/Club/atoms";
import { useFlags } from "../../../../../../../utils/launchDarkly";
import { addPlayerAtom } from "../../../../../atoms/actions/addPlayer/addPlayerAtom";
import { setNonPlayingHostOnRoundAtom } from "../../../../../atoms/actions/setNonPlayingHostOnRoundAtom/setNonPlayingHostOnRoundAtom";

export const useNewGuestSubmission = (isBookingFull: boolean) => {
  const { memberNonPlayingHostToggle } = useFlags();
  const currentProfile = useAtomValue(currentProfileAtom);
  const addPlayerToBooking = useSetAtom(addPlayerAtom);
  const setNonPlayingHostOnRound = useSetAtom(setNonPlayingHostOnRoundAtom);

  const bookingWizardData = useAtomValue(BookingWizardDataAtom);

  const currentGroup = useAtomValue(CurrentRequestGroupIndexAtom);
  const rounds =
    bookingWizardData?.rounds.filter(
      (round) =>
        bookingWizardData.type !== "RequestBooking" ||
        (round.bookingIndex ?? 0) === currentGroup
    ) ?? [];

  const handlePlayerSubmission = (
    values: NewGuestFormProps,
    onFinish?: () => void
  ) => {
    const nameSplit = values.fullName.split(" ");
    const firstName = nameSplit.shift() || "";
    const lastName = nameSplit.join(" ") || "";

    const courseLayoutFromBookingData =
      bookingWizardData?.type === "GolfBooking"
        ? bookingWizardData.courseLayout
        : undefined;

    const isHostInPlayerList = rounds.some(
      (round) => round.player.id === currentProfile?.memberId
    );

    const memberRounds = rounds?.filter(
      (round) => round.player.clientType === "member"
    );

    if (isBookingFull && memberNonPlayingHostToggle) {
      const ownerMemberRound = memberRounds?.[0];
      setNonPlayingHostOnRound(
        { playerId: ownerMemberRound?.player?.id ?? "" },
        true
      );
    }

    // Create a basic GuestPlayer with required properties
    addPlayerToBooking({
      id: uuidv4(),
      firstName,
      lastName,
      clientType: "newGuest",
      hostId:
        isHostInPlayerList && currentProfile?.memberId
          ? currentProfile.memberId
          : memberRounds[0]?.player?.id ?? "",
      courseLayoutCode: courseLayoutFromBookingData?.code || null,
      courseLayoutId: courseLayoutFromBookingData?.id || null,
      courseLayoutName: courseLayoutFromBookingData?.name || null,
      paymentStatus: "MEMBER_BILL",
      transportationType: undefined,
      memberGroups: [],
      profileImagePublicId: null,
    });

    if (onFinish) onFinish();
  };

  return handlePlayerSubmission;
};
